import { useContext } from 'react';
import { Route, Routes, useLocation, Navigate } from 'react-router';

import Login from './pages/Login';
import MainLayout from './layouts/MainLayout';
import BrandDashboard from './pages/BrandDashboard';
import Campaigns from './pages/Campaigns';
import CreateNewCampaign from './pages/CreateNewCampaign';
import Profile from './pages/Profile';
import UserManagement from './pages/UserManagement';
import { AuthContext } from './contexts/AuthContext';
import Merchants from './pages/Merchants';
import { Box, CircularProgress } from '@mui/material';
import CreateNewMerchant from './pages/CreateNewMerchant';
import Vouchers from './pages/Vouchers';
import AffiliateTransactions from './pages/AffiliateTransactions';
import WithdrawalRequests from './pages/WithdrawalRequests';
import TrandingBrandWithdrawalRequests from './pages/TrandingBrandWithdrawalRequests';
import ResetPassword from './pages/ResetPassword';
import TrandingAdminInvoices from './pages/TrandingAdminInvoices';
import Notifications from './pages/Notifications';
import MerchantInvoices from './pages/MerchantInvoices';
import TrandingBrandTransactions from './pages/TrandingBrandTransactions';
import BrandTransactions from './pages/BrandTransactions';
import Account from './pages/Account';
import CampaignsPriority from './pages/CampaignsPriority';
import BrandAnalytics from './pages/BrandAnalytics';
import CampaignAnalytics from './pages/CampaignAnalytics';
import CreateNewProductCampaign from './pages/CreateNewProductCampaign';
import BrandsPriority from './pages/BrandsPriority';
import BrandWithdrawalRequests from './pages/BrandWithdrawalRequests';

export default function RoutesComponent() {
  const { loggedIn, userRole } = useContext(AuthContext);
  const location = useLocation();
  console.log(`loggedIn is ${loggedIn}`);

  if (loggedIn === 'waiting') {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh">
        <CircularProgress />
      </Box>
    );
  }

  if (
    loggedIn === 'logged_out' &&
    location.pathname !== '/login' &&
    !location.pathname.includes('/reset-password')
  ) {
    return <Navigate to="/login" replace />;
  }

  if (loggedIn === 'logged_in' && location.pathname === '/login') {
    return <Navigate to="/dashboard" replace />;
  }

  if (loggedIn === 'logged_in' && location.pathname === '/') {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <Routes>
      <Route path="reset-password" element={<ResetPassword />} />
      {loggedIn === 'logged_out' && <Route path="login" element={<Login />} />}
      {loggedIn === 'logged_in' && userRole === 'tranding_admin' && (
        <>
          <Route path="dashboard" element={<MainLayout />}>
            <Route index element={<BrandDashboard />} />
            <Route path="merchants" element={<Merchants />} />
            <Route
              path="merchants/:merchantId"
              element={<CreateNewMerchant updateMode />}
            />
            <Route path="merchants/new" element={<CreateNewMerchant />} />
            <Route
              path="tranding-merchant-transactions/:merchantId?"
              element={<TrandingBrandTransactions />}
            />
            <Route path="brands-priority" element={<BrandsPriority />} />
            <Route path="campaigns">
              <Route index element={<Campaigns />} />
              <Route
                path="product/:campaignId"
                element={<CreateNewProductCampaign updateMode />}
              />
              <Route
                path=":campaignId"
                element={<CreateNewCampaign updateMode />}
              />
              <Route path="new">
                <Route index element={<CreateNewCampaign />} />
                <Route path="product" element={<CreateNewProductCampaign />} />
              </Route>
            </Route>
            <Route path="campaigns-priority" element={<CampaignsPriority />} />
            <Route
              path="affiliate-transactions"
              element={<AffiliateTransactions />}
            />
            <Route
              path="withdrawal-requests"
              element={<WithdrawalRequests />}
            />
            <Route
              path="brand-withdrawal-requests"
              element={<TrandingBrandWithdrawalRequests />}
            />
            <Route
              path="tranding-admin-invoices"
              element={<TrandingAdminInvoices />}
            />
            <Route
              path="tranding-admin-invoices/:invoiceId"
              element={<TrandingAdminInvoices />}
            />
            <Route path="notifications" element={<Notifications />} />
            <Route
              path="notifications/:notificationId"
              element={<Notifications />}
            />
            <Route path="vouchers" element={<Vouchers />} />
            <Route path="profile" element={<Profile />} />
            <Route path="user-management" element={<UserManagement />} />
          </Route>
          <Route
            path="*"
            element={
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                height="100vh">
                <span>path doesn't exist: {location.pathname}</span>
              </Box>
            }
          />
        </>
      )}
      {/* Brand routes */}
      {loggedIn === 'logged_in' &&
        ['merchant_admin'].includes(userRole ?? '') && (
          <>
            <Route path="dashboard" element={<MainLayout />}>
              <Route index element={<BrandDashboard />} />
              <Route path="campaigns">
                <Route index element={<Campaigns />} />
                <Route
                  path="product/:campaignId"
                  element={<CreateNewProductCampaign updateMode />}
                />
                <Route
                  path=":campaignId"
                  element={<CreateNewCampaign updateMode />}
                />
                <Route path="new">
                  <Route index element={<CreateNewCampaign />} />
                  <Route
                    path="product"
                    element={<CreateNewProductCampaign />}
                  />
                </Route>
              </Route>
              <Route
                path="brand-transactions"
                element={<BrandTransactions />}
              />
              <Route
                path="withdrawal-requests"
                element={<BrandWithdrawalRequests />}
              />
              <Route path="brand-analytics">
                <Route index element={<BrandAnalytics />} />
                <Route path=":campaignId" element={<CampaignAnalytics />} />
              </Route>
              <Route path="profile" element={<Profile />} />
              {/* <Route path="invoices" element={<MerchantInvoices />} />
              <Route
                path="invoices/:invoiceId"
                element={<MerchantInvoices />}
              /> */}
            </Route>
            <Route
              path="*"
              element={
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  height="100vh">
                  <span>path doesn't exist: {location.pathname}</span>
                </Box>
              }
            />
          </>
        )}
      {loggedIn === 'logged_in' &&
        ['merchant_employee'].includes(userRole ?? '') && (
          <>
            <Route path="dashboard" element={<MainLayout />}>
              <Route index element={<BrandDashboard />} />
            </Route>
            <Route
              path="*"
              element={
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  height="100vh">
                  <span>path doesn't exist: {location.pathname}</span>
                </Box>
              }
            />
          </>
        )}
      <Route path="dashboard" element={<MainLayout />}>
        <Route path="account" element={<Account />} />
      </Route>
      <Route
        path="*"
        element={
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            height="100vh">
            <span>path doesn't exist: {location.pathname}</span>
          </Box>
        }
      />
    </Routes>
  );
}
